import { type FC, useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthContext } from "../hooks/authProvider/authProvider";
import AdminDashboardPageContainer from "../routes/admin/AdminDashboardPage/index";
import { TenantDetailPage, TenantsPage } from "../routes/admin/tenants";
import { UserDetailPage, UsersPage } from "../routes/admin/users";
import { canAccessAdminPages } from "../utils/admin-utils";

/**
 * 管理者権限を持つユーザーのみアクセス可能なルートを保護し、
 * 管理者向けのルーティングも担当するコンポーネント
 * @return {JSX.Element} 管理者向けルート保護・ルーティングコンポーネント
 */
export const AdminRoute: FC = () => {
  const { currentUser, isLoadingUser } = useContext(AuthContext);

  // ローディング中またはcurrentUserが取得できていない場合は待機
  if (isLoadingUser || !currentUser) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-lg">管理者権限を確認中...</div>
      </div>
    );
  }

  // currentUserが取得できた後に管理者権限をチェック
  if (!canAccessAdminPages(currentUser)) {
    return <Navigate to="/" replace />;
  }

  // 管理者権限がある場合は管理者向けルーティングを表示
  return (
    <Routes>
      <Route path="/" element={<AdminDashboardPageContainer />} />
      <Route path="/tenants" element={<TenantsPage />} />
      <Route path="/tenants/:id" element={<TenantDetailPage />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/users/:id" element={<UserDetailPage />} />
    </Routes>
  );
};

export default AdminRoute;
